export default function ChooseFigureAxisMoveController(view, model) {
  return ({
    index,
    value
  }) => {
    if (index != 0) return;
    if (value < -0.5) view.selectPrevFigure();else if (value > 0.5) view.selectNextFigure();
  };
}